export default {"src":"/_next/static/media/fidelity-logo.3fc5a7d3.svg","height":33,"width":137};